// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { gql } from 'apollo-angular';

export const contributorTeamQuery = gql`
  query ContributorTeam(
    $organizationId: String!
    $projectId: String
    $dateRange: String
    $isMaintainer: Boolean
    $isContributor: Boolean
    $isCollaborator: Boolean
    $currentEmployeesOnly: Boolean
    $isAllOrgs: Boolean
  ) {
    contributorTeam(
      organizationId: $organizationId
      projectId: $projectId
      dateRange: $dateRange
      isMaintainer: $isMaintainer
      isContributor: $isContributor
      isCollaborator: $isCollaborator
      currentEmployeesOnly: $currentEmployeesOnly
      isAllOrgs: $isAllOrgs
    ) {
      contributorId
      userId
      userDisplayName
      userName
      userPhotoUrl
      jobTitle
      country
      github
      memberEmail
      accountName
      orgAffiliation {
        endDate
        pkid
        startDate
      }
      commitCount
      lastCommitTs
      participationCount
      lastParticipationTs
      isCommitter
      isMaintainer
      isCollaborator
      isContributor
      mostActiveProject
      mostActiveFoundation
      highestType
    }
  }
`;
